import { motion } from 'framer-motion';

import { cn } from 'lib/utils';

interface AnimatedTabButtonProps {
  onClick: () => void;
  isSelected: boolean;
  label: string;
  className?: string;
}

export default function AnimatedTabButton({
  onClick,
  isSelected,
  label,
  className,
}: AnimatedTabButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'text-base transition-colors py-1.5 rounded-3xl relative font-semibold w-fit lg:w-48',
        isSelected ? 'text-white' : 'text-gray-900',
        className
      )}
    >
      <span className='relative z-10'>{label}</span>
      {isSelected && (
        <motion.span
          layoutId='pill-tab'
          transition={{ type: 'spring', duration: 0.5 }}
          className='absolute inset-0 z-0 rounded-3xl bg-primary'
        />
      )}
    </button>
  );
}
